import fetchRequest from './utils';

export const makeRequestSaveProfile = (body) => fetchRequest('/profile', 'POST', null, body);

export const makeRequestSaveDeliverySettings = (body) => fetchRequest('/profile/settings', 'PATCH', null, body);
